<template>
  <main class="mobile-menu flex-col" role="dialog" aria-modal="true" aria-label="网站导航">
    <div class="mobile-menu__backdrop flex-col" @click.self="closeMenu">
      <div class="mobile-menu__panel flex-col">
        <button class="mobile-menu__close flex-row" type="button" aria-label="关闭导航菜单" @click="closeMenu">
          <img
            class="mobile-menu__close-icon"
            alt=""
            src="@/assets/pages/menu/images/53c5038e85c62454d759b5f02875c6d7.png"
          />
        </button>
        <nav class="mobile-menu__navigation" aria-label="主导航">
          <router-link
            v-for="item in primaryNavigation"
            :key="item.name"
            :to="{ name: item.name }"
            class="mobile-menu__link flex-row"
            @click.native="closeMenu"
          >
            <span class="mobile-menu__label">{{ item.label }}</span>
          </router-link>
        </nav>
      </div>
    </div>
  </main>
</template>

<script>
import primaryNavigation from '@/config/navigation'

export default {
  name: 'MobileMenu',
  data() {
    return { primaryNavigation }
  },
  methods: {
    closeMenu() {
      this.$emit('close')

      if (this.$route.name !== 'menu') return

      const returnRoute = this.$route.query.from
      const canReturn = primaryNavigation.some(item => item.name === returnRoute)
      this.$router.replace({ name: canReturn ? returnRoute : 'home' })
    }
  }
}
</script>

<style scoped lang="css" src="@/assets/pages/menu/styles/index.response.css" />
